import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容导航
          </h2>
          <p className="text-foreground-500 text-sm max-w-[500px] mx-auto">
            选择您感兴趣的分类，快速找到所需信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                <span>浏览更多</span>
                <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}